import { colors } from 'components/src/foundation';
import { Check } from 'components/src/svg';
import { Paragraph } from 'components/src/typography';
import * as React from 'react';

type Props = {
  title: string;
};

const CheckListItem = ({ title }: Props) => {
  return (
    <div className="flex items-center gap-8">
      <Check color={colors.red[100]} />
      <Paragraph>{title}</Paragraph>
    </div>
  );
};
export default CheckListItem;
